'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://octicons.github.com/icon/star/
var star = _react2.default.createElement(
  'svg',
  {
    height: '32',
    className: 'Ratings-item-star',
    viewBox: '0 0 14 16',
    version: '1.1',
    width: '28',
    'aria-hidden': 'true'
  },
  _react2.default.createElement('path', {
    fillRule: 'evenodd',
    d: 'M14 6l-4.9-.64L7 1 4.9 5.36 0 6l3.6 3.26L2.67 14 7 11.67 11.33 14l-.93-4.74z'
  })
);

var propTypes = {
  onClick: _propTypes2.default.func.isRequired,
  isSelected: _propTypes2.default.bool.isRequired
};

var RatingsItem = function RatingsItem(_ref) {
  var onClick = _ref.onClick,
      isSelected = _ref.isSelected;

  var classes = (0, _classnames2.default)('Ratings-item', { 'Ratings-item--isSelected': isSelected });

  /* eslint-disable jsx-a11y/no-static-element-interactions */
  return _react2.default.createElement(
    'li',
    { className: classes, onClick: onClick, tabIndex: '0' },
    star
  );
  /* eslint-enable jsx-a11y/no-static-element-interactions */
};

RatingsItem.propTypes = propTypes;

exports.default = RatingsItem;